import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgVk({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.254 15.1c-.536-.63-1.166-1.17-1.763-1.741-.538-.516-.572-.815-.14-1.41.473-.65.98-1.274 1.457-1.92.445-.604.9-1.207 1.134-1.93.149-.46.017-.663-.463-.744a1.512 1.512 0 00-.253-.015l-2.852-.003c-.351-.005-.546.145-.67.45-.168.414-.34.827-.54 1.225-.454.904-.96 1.778-1.67 2.518-.156.163-.33.369-.59.284-.328-.117-.424-.646-.419-.825l-.003-3.232c-.063-.461-.167-.667-.634-.757H9.885c-.395 0-.594.15-.805.393-.122.14-.158.232.092.278.492.092.769.404.842.888.118.773.11 1.55.042 2.326a2.13 2.13 0 01-.151.665c-.144.332-.375.4-.679.196-.275-.186-.468-.447-.657-.71a15.535 15.535 0 01-1.74-3.165c-.134-.323-.364-.518-.712-.524a74.046 74.046 0 00-2.567.001c-.515.01-.669.255-.46.713.933 2.035 1.97 4.014 3.324 5.816.695.925 1.494 1.741 2.525 2.32 1.168.656 2.427.853 3.752.793.62-.029.806-.187.835-.794.02-.416.067-.829.276-1.202.205-.366.515-.436.873-.208.179.114.33.26.472.412.349.375.686.762 1.048 1.124.455.454.993.723 1.67.668h2.622c.422-.027.64-.535.398-.998a4.96 4.96 0 00-.63-.892z"
        fill={color}
      />
    </svg>
  )
}

export default SvgVk
